<template>
	<div class="ptlr-15-16 box-s">
		<div class="flexs mb-10 ">
			<div class="title_line h15"></div>
			<div class="fw-500 fz-16 c1 ml-8 l-h-16 mt-1">积分规则</div>
		</div>
		<div v-if="txt">
			<div v-html="txt"></div>
		</div>
		<noData v-if="show"></noData>
		<loading :loadFlag="loadFlag"></loading>
	</div>

</template>
<script>
  import noData from "@/components/noData"
  import { integralRule } from '@/api/api.js'
	import loading from "@/components/loading"
	export default {
		components: {
      noData,
			loading
		},
		data() {
			return {
			  txt: '',
				show: false,
				loadFlag: false
			};
		},
		created() {
      this.initData()
		},
		methods: {
			async initData(){
				this.loadFlag = true
				const res = await integralRule()
				this.loadFlag = false
				if(res.code == 1000){
          this.txt = res.data
					if(!res.data){
						this.show = true
					}
				}else {
					 this.$toast(res.msg)
				}
			}
		}
	}
</script>
<style lang="less" scoped>

</style>
